export const additionalSkills = [
  {
    id: "1",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
    title: "HTML",
    href: "https://en.wikipedia.org/wiki/HTML",
  },
  {
    id: "2",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
    title: "CSS",
    href: "https://en.wikipedia.org/wiki/CSS",
  },
  {
    id: "3",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sass/sass-original.svg",
    title: "SASS/SCSS",
    href: "https://sass-lang.com/",
  },
  {
    id: "4",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
    title: "JavaScript",
    href: "https://en.wikipedia.org/wiki/JavaScript",
  },
  {
    id: "5",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
    title: "TypeScript",
    href: "https://www.typescriptlang.org/",
  },
  {
    id: "6",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
    title: "React",
    href: "https://react.dev",
  },
  {
    id: "7",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
    title: "Redux Toolkit",
    href: "https://redux-toolkit.js.org/",
  },
  {
    id: "8",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
    title: "Vue",
    href: "https://vuejs.org/",
  },
  {
    id: "9",
    image: "https://pinia.vuejs.org/logo.svg",
    title: "Pinia",
    href: "https://pinia.vuejs.org/",
  },
  // {
  //   id: "10",
  //   image:
  //     "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/gulp/gulp-plain.svg",
  //   title: "Gulp",
  //   href: "https://gulpjs.com/",
  // },
  {
    id: "11",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/webpack/webpack-original.svg",
    title: "Webpack",
    href: "https://webpack.js.org/",
  },
  {
    id: "12",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg",
    title: "Vite",
    href: "https://vitejs.dev/",
  },
  {
    id: "13",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg",
    title: "Git",
    href: "https://git-scm.com/",
  },
  // {
  //   id: "14",
  //   image:
  //     "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
  //   title: "TailwindCSS",
  //   href: "https://tailwindcss.com/",
  // },
  {
    id: "15",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg",
    title: "PHP",
    href: "https://www.php.net/",
  },
  {
    id: "16",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/wordpress/wordpress-plain.svg",
    title: "WordPress",
    href: "https://wordpress.org/",
  },
  {
    id: "17",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg",
    title: "Node",
    href: "https://nodejs.org/ru",
  },
];
